<template>
  <a-modal
    :title="addCommentTit"
    class="add-comment-modal"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :mask-closable="false"
    :width="640"
    :ok-text="saveTxt"
    :cancel-text="cancelTxt"
    @ok="addComment"
    @cancel="handleCancel"
  >
    <a-form
      v-if="permissionInfo.is_add_comments"
      :form="form"
    >
      <a-form-item
        :label="`${modalTit}：`"
        class="add-box clearfix"
      >
        <div class="textarea clearfix">
          <a-textarea
            v-decorator="['content', {
              rules: [{ required: true, message: noEmpty}],
              initialValue: comment.new || ''
            }]"
            :placeholder="commentPlace"
            class="fl"
          />
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      comment: {
        new: ''
      }
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    saveTxt () {
      return this.$t('message["21"]')
    },
    noEmpty () {
      return this.$t('message["67"]')
    },
    modalTit () {
      return this.$t('message["716"]')
    },
    commentPlace () {
      return this.$t('message["791"]')
    },
    addCommentTit () {
      return this.$t('message["1351"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('inquery/detailData', [
      'inquiryAddComment'
    ]),
    hide () {
      this.$emit('update:visible', false)
    },
    async addComment () {
      if (this.confirmLoading) return

      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.comment.new = this.form.getFieldValue('content')
          this.confirmLoading = true
          const chain = await this.inquiryAddComment()
          chain
            .params({
              inquiryid: this.inquiryId,
              content: this.comment.new
            })
            .onNetSuccess(raw => {
              this.confirmLoading = false
              this.hide()
            })
            .onSuccess(res => {
              this.form.resetFields()
              this.comment.new = ''
              this.$bus.$emit('getCommentList')
            })
            .fetch()
        }
      })
    },
    handleCancel () {
      this.hide()
      this.form.resetFields()
      this.comment.new = ''
      this.confirmLoading = false
    }
  }
}
</script>

<style lang="scss">
.add-comment-modal {
  .ant-modal-body {
    padding: 40px;
  }
  .ant-form-item-label, .ant-form-item-control-wrapper {
    float: left
  }
  .ant-form-item-label {
    min-width: 86px;
  }
  .add-box {
    textarea.ant-input {
      display: block;
      width: 474px;
      height: 200px;
    }
    .placeholder {
      margin-left: 16px;
    }
  }
}
</style>
